import { render, staticRenderFns } from "./EntityNews.vue?vue&type=template&id=ae9c27ce&scoped=true&"
import script from "./EntityNews.vue?vue&type=script&lang=js&"
export * from "./EntityNews.vue?vue&type=script&lang=js&"
import style0 from "./EntityNews.vue?vue&type=style&index=0&id=ae9c27ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9c27ce",
  null
  
)

export default component.exports